import { useState } from "react";
import { Col, Input, Row } from "reactstrap";
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";
import styles from "./OrderMaterial.module.scss";
import PricingTable from "./PricingTable/PricingTable";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";
import MaelanoIcon from "../../../../../assets/icons/MaelanoIcon.png";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import Divider from "../../../../../components/common/Divider/Divider";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import AddBankAccountModal from "./AddBankAccountModal/AddBankAccountModal";
import AddDebitCardModal from "./AddDebitCardModal/AddDebitCardModal";

const OrderMaterial = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [modalState, setModalState] = useState({
    addBankAccount: false,
    addDebitCard: false,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setModalState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    if (name === "addBankAccount" && checked) {
      setIsAddBankAccountModalOpen(true);
    } else if (name === "addDebitCard" && checked) {
      setIsAddDebitCardModalOpen(true);
    }

    setIsDropdownOpen(false);
    setModalState({
      addBankAccount: false,
      addDebitCard: false,
    });
  };

  const [isAddBankAccountModalOpen, setIsAddBankAccountModalOpen] =
    useState(false);
  const [isAddDebitCardModalOpen, setIsAddDebitCardModalOpen] = useState(false);

  const bankAccountsData = [
    { name: "Meezan bank", accountNumber: "**********1234" },
    { name: "HBL bank", accountNumber: "**********1234" },
    { name: "UBL bank", accountNumber: "**********1234" },
  ];

  const bankAccountsColumns = [
    { name: "Bank Name", selector: (row) => row.name, minWidth: "120px" },
    { name: "Account number", selector: (row) => row.accountNumber, minWidth: "160px" },
    { name: "Select", cell: () => <Input type="checkbox" />, center: "true" },
  ];

  const creditCardData = [
    { name: "Visa", accountNumber: "**********1234" },
    { name: "Mastercard", accountNumber: "**********1234" },
  ];

  const creditCardColumns = [
    { name: "Card Type", selector: (row) => row.name, minWidth: "120px" },
    { name: "Account number", selector: (row) => row.accountNumber, minWidth: "160px" },
    { name: "Select", cell: () => <Input type="checkbox" />, center: "true" },
  ];

  return (
    <div>
      <YellowHeaderWrapper title={"Packaging Material Selection"}>
        <PricingTable />
      </YellowHeaderWrapper>

      <YellowHeaderWrapper title={"Delivery Options"}>
        <div className="d-flex gap-5">
          <div className="d-flex gap-1">
            <div className="d-flex flex-column justify-content-center">
              <div>
                <Input type="checkbox" />
              </div>
              <div>
                <Input type="checkbox" />
              </div>
              <div>
                <Input type="checkbox" />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-center">
              <div>Express delivery</div>
              <div>Standard delivery</div>
              <div>Economy delivery</div>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center">
            <div>
              Expected <span className={styles["text-orange"]}>2-3</span> days
            </div>
            <div>
              Expected <span className={styles["text-orange"]}>4-5</span> days
            </div>
            <div>
              Expected <span className={styles["text-orange"]}>5-7</span> days
            </div>
          </div>
          <div className={`${styles["text-orange"]}`}>
            <div>$8</div>
            <div>$5</div>
            <div>$3</div>
          </div>
        </div>
      </YellowHeaderWrapper>

      <YellowHeaderWrapper title={"Payment Method"}>
        <Row className="g-0 d-flex row-gap-5">
          <Col xl={8} className="pe-xl-3">
            <div className="d-flex gap-2 mb-2 align-items-start align-items-xxl-center justify-content-between flex-column flex-xxl-row">
              <div className="fw-medium">
                Choose a payment method from saved one. Or you can add new.
              </div>
              <div className="position-relative align-self-end">
                <PrimaryButton
                  name={"Add Payment Method"}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                />
                {isDropdownOpen && (
                  <div className={styles.dropdown}>
                    <div className="d-flex gap-1 align-items-center">
                      <Checkbox
                        id="addBankAccount"
                        name="addBankAccount"
                        checked={modalState.addBankAccount}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="addBankAccount">Add Bank Account</label>
                    </div>
                    <div className="d-flex gap-1 align-items-center mt-2">
                      <Checkbox
                        id="addDebitCard"
                        name="addDebitCard"
                        checked={modalState.addDebitCard}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="addDebitCard">
                        Add Credit/Debit Card
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="fw-semibold fs-5">Maelano Wallet</div>
            <div className="border border-subtle-secondary p-2">
              <div className="border border-subtle-secondary p-3 d-flex align-items-center gap-3">
                <div>
                  <img src={MaelanoIcon} alt="" />
                </div>
                <div>
                  <Input type="checkbox" />
                </div>
              </div>
            </div>
            <div className="fw-semibold fs-5">Bank Accounts</div>
            <div className="border border-subtle-secondary p-2">
              <div className="border border-subtle-secondary p-3 gap-3">
                <DatatableComponent
                  data={bankAccountsData}
                  columns={bankAccountsColumns}
                  type={"gray"}
                />
              </div>
            </div>

            <div className="fw-semibold fs-5">Credit/Debit Cards</div>
            <div className="border border-subtle-secondary p-2">
              <div className="border border-subtle-secondary p-3 gap-3">
                <DatatableComponent
                  data={creditCardData}
                  columns={creditCardColumns}
                  type={"gray"}
                />
              </div>
            </div>
          </Col>

          <Col xl={4} className="flex-grow-1 fw-medium d-flex align-items-center ps-xl-3">
            <div className="flex-grow-1">
              <div className={`${styles["right-section-wrapper"]} shadow`}>
                <div className="fw-semibold fs-5 text-center">
                  Order Summary
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <img src="" alt="" width={67} height={61} />
                  </div>
                  <div>
                    <div>Boxes</div>
                    <div className={styles["text-orange"]}>$33.99</div>
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <img src="" alt="" width={67} height={61} />
                  </div>
                  <div>
                    <div>Bubble Wrap</div>
                    <div className={styles["text-orange"]}>$33.99</div>
                  </div>
                </div>

                <Divider />

                <Row>
                  <Col>Subtotal:</Col>
                  <Col>$67.98</Col>
                </Row>
                <Row>
                  <Col>Delivery charges:</Col>
                  <Col>$4.00</Col>
                </Row>
                <Row>
                  <Col>Discount:</Col>
                  <Col>$00.00</Col>
                </Row>

                <Divider />

                <Row>
                  <Col className="fw-bold">Total:</Col>
                  <Col className={styles["text-orange"]}>$71.98</Col>
                </Row>
              </div>
              <div className="text-center">
                <PrimaryButton name={"Place Order"} />
              </div>
            </div>
          </Col>
        </Row>
      </YellowHeaderWrapper>

      <AddBankAccountModal
        isModalOpen={isAddBankAccountModalOpen}
        setIsModalOpen={setIsAddBankAccountModalOpen}
      />
      <AddDebitCardModal
        isModalOpen={isAddDebitCardModalOpen}
        setIsModalOpen={setIsAddDebitCardModalOpen}
      />
    </div>
  );
};

export default OrderMaterial;